<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                Роли организаций
            </template>
            <h2>Роли организаций</h2>
            <template #actions>
                <div class='d-flex align-items-baseline actions'>
                    <side-checkbox-component
                        id='chbx_organ'
                        v-model='isShowOrgan'
                        @change='loadPage'>
                      Органы власти
                    </side-checkbox-component>

                    <button-component kind="tertiary" :class="{filtered: isFiltered}" @click="modals.filter = !modals.filter">
                        <template #prepend>
                            <icon-component class="mr-2" name="filter" />
                        </template>
                        Фильтр
                    </button-component>
                </div>
            </template>
        </page-header>
        <section class="content">
            <template v-if="page">
                <template v-if="page.items.length">
                    <div class="table-inner ">
                    <table class="table-custom">
                        <thead>
                        <tr>
                            <th width="50px"></th>
                            <th  class="text-center">ID</th>
                            <th>Название</th>
                            <th>ИНН</th>
                            <th>ОГРН</th>
                            <th>Роли</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in page.items" :key="item.id">
                            <td><menu-component class="actions" :actions="Actions(item)"/></td>
                            <td class="table-action-cell text-center">
                                <input type="checkbox" v-model="selectedIds" :true-value="[]" :value="item.id">
                                <span>{{ item.id }}</span>
                            </td>
                            <td>{{ item.name ? item.name : item.nameFull }}</td>
                            <td>{{ item.inn }}</td>
                            <td>{{ item.ogrn }}</td>
                            <td>
                                {{formatRoles(item)}}
                            </td>

                        </tr>
                        </tbody>
                    </table>
                    </div>
                    <div>
                        <action-bar
                                v-if="canEdit"
                                v-show="actions.length && selectedIds.length"
                                default-action="add_roles"
                                :actions="actions"
                                @execute="executeAction($event)"
                        />
                    </div>
                    <div v-if="page.pagesTotal > 1">
                        <Pagination
                                :page-count="page.pagesTotal"
                                :current-page="page.pageNumber"
                                @change="onPageChange($event)"
                        />
                    </div>
                    <div>
                      <PageCounter :isFiltered="isFiltered" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
                    </div>
                </template>
                <template v-else>
                    <EmptyListMessage />
                </template>
            </template>
            <section class="modals">
                <transition name="filter">
                    <div class="filter" v-if="modals.filter">
                        <OrganizationsFilter
                                v-bind:filters="filters" v-bind:organ-mode='isShowOrgan'
                                admin-mode="true"
                                v-on:apply="onFiltersApply($event)"
                                v-on:reset="onFiltersReset($event)"
                        />
                    </div>
                </transition>
            </section>
        </section>
    </div>
</template>

<script>
  import PageHeader from "../../../common/components/page/PageHeader";
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import IconComponent from "../../../common/ui/IconComponent";
  import EmptyListMessage from "../../../common/components/EmptyListMessage";
  import OrganizationsFilter from "../../organization/components/OrganizationsFilter";
  import {mapState} from "vuex";
  import ActionBar from "../../../common/components/ActionBar";
  import RoleApi from "../api/roles";
  import Constants from "../../../common/constants";
  import security from "../../../common/mixins/security";
  import MenuComponent from "../../../common/ui/components/page/MenuComponent";
  import filtermanager from "../../../common/mixins/filtermanager";
  import SideCheckboxComponent from "@/common/ui/sideCheckboxComponent";
  import Api from '@/modules/admin/api/organizations';
  import PageCounter from "@/common/components/PageCounter";
  export default {
    name: "OrganizationsAdmin",
    components: {
      MenuComponent,
      ActionBar, OrganizationsFilter, EmptyListMessage, IconComponent, ButtonComponent, PageHeader, SideCheckboxComponent, PageCounter},
    mixins: [security, filtermanager],
    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
          getRoles: true
        },
        filters: {
          districtIds: [],
          serviceTypeId: 0,
          name: '',
          ogrn: '',
          dateRegistration: null,
          dateLastChange: null,
          opfIds: [],
          inn: '',
          organizationTypeId: 0,
          organizationSubtypeId: 0,
          roleIds: [],
        },
        modals: {
          filter: false
        },
        roles: [],
        actions: [],
        selectedIds: [],
        canEdit: true,
        isFiltered: false,
        isShowOrgan: false,
        totalCount: 0
      };
    },
    created() {
      //загрузить по-умолчанию
      this.request.pageNumber = this.$route.query.page ? this.$route.query.page * 1 : 1;
      this.checkPermission(Constants.OrganizationRoleEdit).then((response) => {
        this.canEdit = response.data;
      });
      const self = this;
      Api.search({getRoles: true, pageNumber: 1, pageSize: 1}).then(function (response) {
        self.totalCount = response.data.itemsTotal;
      });
      this.loadPage();
      RoleApi.search({pageNumber: 1, pageSize: -1})
          .then((response) => {
            this.roles = response.data.items
              .map((item) => ({id: item.id, text: item.name}));
            this.initActions();
          });
    },
    methods: {
      editCard(id) {
        this.$router.push({name: 'editOrganizationAdmin', params: {id: id, action: 'edit'}, query: { page: this.request.pageNumber }})
      },
      Actions(item) {
        return [
          {
            title: 'Редактировать',
            icon: 'pen',
            click: () => this.editCard(item.id)
          },
        ]
      },
      loadPage() {
        const filter = this.loadFilter();
        if (filter) {
          this.filters = filter;
          this.isFiltered = true;
        }

        var params = Object.assign(Object.assign(this.filters, this.request), {
          isOrgan: this.isShowOrgan
        });
        this.$store.dispatch("admin/organizations/searchOrganizations", params);
      },
      initActions() {
        const ph = 'Выберите роль';
        this.actions.push({code: 'add_roles', title: 'Назначить роль', options: this.roles, placeholder: ph});
        this.actions.push({code: 'remove_roles', title: 'Убрать роль', options: this.roles, placeholder: ph});
      },
      executeAction(action) {
        switch (action.code) {
          case 'add_roles':
            RoleApi.addRolesToOrganizations({organizationIds: this.selectedIds, roleIds: action.ids})
              .then(() => {
                this.loadPage();
                this.selectedIds = [];
              });
            break;
          case 'remove_roles':
            RoleApi.removeRolesFromOrganizations({organizationIds: this.selectedIds, roleIds: action.ids})
              .then(() => {
                this.loadPage();
                this.selectedIds = [];
              });
            break;
        }
      },
      formatRoles(item) {
        return item.roles?.length ? item.roles.map(x => x.role.name).join(', ') : '';
      },
      onFiltersApply(filters) {
        this.filters = filters;
        this.request.pageNumber = 1;
        this.modals.filter = false;
        this.saveFilter(this.filters);
        this.isFiltered = true;
        this.loadPage();
      },
      onFiltersReset(filters) {
        this.filters = filters || {};
        this.request.pageNumber = 1;
        this.modals.filter = false;
        this.removeFilter();
        this.isFiltered = false;
        this.loadPage();
      },
      onPageChange(pageNumber) {
        this.request.pageNumber = pageNumber;
        this.$router.push({
          query: {
              ...this.$route.query,
              page: pageNumber
            }
        });
        this.loadPage();
      }
    },
    computed: {
      ...mapState({
        page: (state) => state.admin.organizations.listPage
      })
    },
    watch: {
      '$route.query.page': {
        handler(newVal) {
          this.request.pageNumber = newVal ? newVal * 1 : 1;
          this.loadPage();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '/src/assets/theme/default/colors.scss';

    .content{
        padding: 16px 16px 0 16px;
        position: relative;
        overflow-y: visible;
        .filter{
            position: absolute;
            width: 350px;
            height: auto;
            top: 0;
            right: 0;
            overflow: hidden;
            background-color: transparent;
            opacity: 1;
            transition: opacity .2s;
        }
        .filter-enter, .filter-leave-to {
            opacity: 0;
        }
    }
    .filtered {
        color: $red;
        &:hover {
            color: $red-dark;
        }
    }
    .table-action-cell {
        input {
            margin-right: 8px;
            padding-top: 4px;
        }
        width: 10%;
    }
</style>
<style lang="scss">
    .select2-selection__choice {
        color: inherit !important;
    }
</style>